import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const AgencyFilterHeaderItem = ({ active, title, id, onClickHandler }) => {
  const clickHandler = () => {
    onClickHandler(id);
  };

  return (
    <button
      onClick={clickHandler}
      className={cn('agency-filter__header-item', {
        'agency-filter__header-item--active': active
      })}
    >
      {title}
    </button>
  );
};

AgencyFilterHeaderItem.propTypes = {
  active: PropTypes.bool,
  title: PropTypes.string,
  onClickHandler: PropTypes.func,
  id: PropTypes.string
};

export default AgencyFilterHeaderItem;
